import React, { Component } from "react";
import {
  configLast3Years,
  transformResponseLastThreeYearsToTable,
  yearOptions,
} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { configNo } from "../config";
import * as R from "ramda";
import { service } from "./service";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";

class LastThreeYearsSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      chartLast3Years: null,
      idLeader: null,
      dataChart: {
        data: [],
        dataKey: [],
      },
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      tableConfig: [
        ...configNo,
        { name: "name", label: "Nama TL", options: { sort: false } },
        ...configLast3Years(),
      ],
    }), ()=> this.fetchData());
  }

  componentDidUpdate = async (prevProps) => {
    if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch) {
      this.fetchData();
    }
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  fetchData = async () => {
    console.log(this.props.idLeader);
    
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhir,
      setError: this.props.setError,
      menuName: "Dashboard Level Team Leader - Laporan Jualan 3 Tahun Terakhir",
      args: {
        kodeCabang: [this.props.kodeCabang?.value],
        year: this.state.year?.value,
        mode: "LEADER",
        idLeader: this.props.idLeader,
        idSalesman: null,
      },
    });
    this.props.onSuccessSearch()
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const dtTable = transformResponseLastThreeYearsToTable(res.data.data);
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: dtTable,
        dataChart: service.transformChartData(dtTable, this.state.tableConfig),
      }));
    }
    this.props.triggerLoading();
  };

  handleSearch = () => {
    this.fetchData();
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        tableConfig: [
          ...configNo,
          { name: "name", label: "Nama TL", options: { sort: false } },
          ...configLast3Years(prev.year?.value),
        ],
      }),
      () => this.fetchData(),
    );
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        )}
        {this.state.chartVisible && (
          <CardBiaxialChart
            data={this.state.dataChart.data}
            dataKey={this.state.dataChart.dataKey}
          />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default LastThreeYearsSalesReport;
